export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA-aIaU3RzhikpMuPgXBUje5zQ2S-2v1aA",
    authDomain: "nequotes-fd.firebaseapp.com",
    projectId: "nequotes-fd",
    storageBucket: "nequotes-fd.firebasestorage.app",
    messagingSenderId: "184186901744",
    appId: "1:184186901744:web:b4274d0bb7618321351e35"
  }
};
